<template>
    <div class="d-flex flex-column flex-md-row align-items-start px-3 ps-0 pt-1 pb-2 mt-1 article-layout" :class="getClass(index)" v-bind="bindData">
        <div class="d-flex flex-column flex-grow-1 ms-0 mx-5">
            <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between mt-3 mt-md-0 gap-md-3">
                <vnodes v-if="getItem('title')" :vnodes="getItem('title')" />
            </div>

            <div class="d-flex flex-column flex-md-row gap-md-1 mt-2 mt-md-1">
                <vnodes v-if="getItem('created')" :vnodes="getItem('created')" />
                <vnodes v-if="getItem('likes')" :vnodes="getItem('likes')" />
                <vnodes v-if="getItem('views')" :vnodes="getItem('views')" />
            </div>
        </div>

        <div class="d-flex align-items-center gap-2">
            <vnodes :vnodes="images()" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, inject, provide, useSlots, useAttrs } from 'vue';
import { Header, travel } from '../helpers';

export interface Props
{
    index: number;
    item: any;
    headers: Header[];
}

defineOptions({
    name: 'list-view-utils-flex',
    components: {
        'vnodes': (props: Record<string, any>, context: any) => props.vnodes
    },
    inheritAttrs: false
});

const $slots = useSlots();
const $attrs = useAttrs();
const props = withDefaults(defineProps<Props>(), {});
const item = computed(() => props.item);
const rowClass = inject<(item: any, i: number) => Record<string, boolean> | string[] | string>('row-class');

const bindData = computed(() => ({
    style: $attrs.style
}));

provide('item', item);

const getClass = (index: number): any =>
{
    let result: any = {};

    if (rowClass)
    {
        result = Object.assign(result, rowClass(props.item, props.index));
    }

    return result;
};

const cells = (): any[] =>
{
    const allowed = [
        'list-view-header',
        'list-view-item',
        'list-view-label',
        'list-view-buttons',
        'list-view-image',
        'list-view-checkbox'
    ];
    const prefix = (new Date()).getTime();

    return travel($slots.default(), allowed)
        .map((p, i) =>
        {
            p.key = `${prefix}-${i}`;
            p.props = p.props || {};
            p.props.index = i;
            p.props.header = props.headers[i];

            return p;
        })
        .orderBy(p => p.props.header.position)
        .toArray();
};

const filter = (tagName: string): any[] =>
{
    return cells().filter(p => p.type.name == tagName);
};

const items = (): any[] =>
{
    return filter('list-view-item');
};

const getItem = (name: 'picture'|'title'|'created'|'views'|'likes'): any =>
{
    return items().find(el => el.props.name === name);
};

const images = (): any[] =>
{
    return filter('list-view-image');
};
</script>

<style lang="scss">
.article-layout {
    border-left: 3px solid transparent;
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
    cursor: pointer;
}
</style>
